import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=728dac96&scoped=true&"
import script from "./button-group.vue?vue&type=script&lang=js&"
export * from "./button-group.vue?vue&type=script&lang=js&"
import style0 from "./button-group.vue?vue&type=style&index=0&id=728dac96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728dac96",
  null
  
)

export default component.exports